<template>
  <aside ref="sidebar" id="sidebar">
    <ul>
      <li @click="navigateToHome">
        <span class="logo">Inventech</span>
        <img src="@/assets/imgs/logo.png" class="img-fluid" alt="Logo Inventech" width="40">
      </li>
      <li :class="{ active: isActiveRoute('home') }">
        <a @click="navigateToHome">
          <home-icon />
          <span>{{$t('navbar.home')}}</span>
        </a>
      </li>
      <li :class="{ active: isActiveRoute('academy') }">
        <a @click="navigateToAcademy">
          <school-icon />
          <span>{{ $t('navbar.academy') }}</span>
        </a>
      </li>
      <li :class="{ active: isActiveRoute('groups') }">
        <a @click="navigateToGroups">
          <account-group-outline-icon />
          <span>{{ isTutor ? $t('academy.my-groups') : $t('navbar.courses') }}</span>
        </a>
      </li>
   
      <li :class="{ active: activateProjects }">
        <a @click="navigateToAllProjects">
          <lightbulb-on-outline-icon />
          <span>{{$t('navbar.projects')}}</span>
        </a>
      </li>
            <li>
        <a @click="toggleUserMenu" class="account-menu-toggle">
          <account-circle-icon />
          <span>{{$t('navbar.account')}}</span>
        </a>
        <div class="user-menu-wrapper" v-if="showUserMenu">
          <user-dropdown-menu/>
        </div>
      </li>
      <li>
        <a @click="toggleLanguageDropdown" class="language-selector">
          <img
            src="@/assets/imgs/iconoIdiomas.png"
            class="img-fluid"
            alt="Lang icon"
            width="20"
          />
          <span>{{$t('navbar.lang')}}</span>
        </a>
        <div class="language-dropdown" v-if="showLanguageDropdown" ref="languageDropdown">
          <a @click="setLocale('pt')">PT</a>
          <a @click="setLocale('es')">ES</a>
          <a @click="setLocale('en')">EN</a>
        </div>
      </li>
      
      <!-- Separador solo visible si es admin -->
      <li v-if="isEducationalInstitutions || isSuperAdmin" class="admin-separator">
        <div class="separator-line"></div>
      </li>
      
      <li v-if="isEducationalInstitutions">
        <a @click="toggleUserMenuTest" class="account-menu-toggle">
          <cog-outline-icon />
          <span>Backoffice</span>
        </a>
        <div v-if="showUserMenuTest" class="user-menu-wrapper">
          <user-dropdown-menu-test :isEducationalInstitutions="isEducationalInstitutions" :institutionData="institutionData"/>
        </div>
      </li>
      <li v-if="isSuperAdmin">
        <a @click="toggleSuperAdminMenu" class="account-menu-toggle">
          <shield-crown-outline-icon />
          <span>SuperAdmin</span>
        </a>
        <!-- ✅ USAR CLASE ESPECÍFICA PARA SUPERADMIN -->
        <div v-if="showSuperAdminMenu" class="super-admin-menu-wrapper">
          <super-admin-dropdown-menu @close="showSuperAdminMenu = false"/>
        </div>
      </li>
    </ul>
    <div class="footer">
      &copy; {{currentYear}} Inventech
    </div>
  </aside>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'; 
import HomeIcon from "vue-material-design-icons/Home.vue";
import SchoolIcon from "vue-material-design-icons/School.vue";
import AccountGroupOutlineIcon from "vue-material-design-icons/AccountGroupOutline.vue";
import LightbulbOnOutlineIcon from "vue-material-design-icons/LightbulbOnOutline.vue";
import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue";
import academyData from '@/data/academyData';
import { getAuth } from 'firebase/auth';
import UserDropdownMenu from '@/views/user/UserDropdownMenu.vue';
import UserDropdownMenuTest from '@/views/TestEducationalInstitutions/UserDropdownMenuTest.vue';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import educationalInstitutionsData from '@/data/educationalInstitutionsData';
import CogOutlineIcon from "vue-material-design-icons/CogOutline.vue";
import ShieldCrownOutlineIcon from "vue-material-design-icons/ShieldCrownOutline.vue";
import SuperAdminDropdownMenu from './SuperAdminDropdownMenu.vue';


export default {
  name: 'NavBarAcademy',
  components: {
    HomeIcon,
    SchoolIcon,
    AccountGroupOutlineIcon,
    LightbulbOnOutlineIcon,
    AccountCircleIcon,
    UserDropdownMenu,
    UserDropdownMenuTest,
    CogOutlineIcon,
    ShieldCrownOutlineIcon,
    SuperAdminDropdownMenu
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      isTutor: false,
      showLanguageDropdown: false,
      showUserMenu: false, // Control para mostrar/ocultar el menú de usuario
      activateProjects: false,
      showUserMenuTest: false,
      isEducationalInstitutions: false,
      institutionData: null,
      isSuperAdmin: false,
      showSuperAdminMenu: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', "user"]),
  },
  async mounted() {
    await this.checkAdminStatus();
    await this.checkUserRole();
    await this.checkSuperAdminStatus();
    
    // Añadir event listener para cerrar el menú al hacer clic fuera
    document.addEventListener('click', this.handleClickOutside);
    
    // Verificar si estamos en la ruta de proyectos al cargar
    this.checkProjectsRoute();
  },
  watch: {
    // Vigilar cambios en la ruta para actualizar activateProjects
    '$route': 'checkProjectsRoute'
  },
  beforeDestroy() {
    // Remover event listener al destruir componente
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    async checkSuperAdminStatus() {
      if (!this.user?.uid) return;
      
      try {
        const db = getFirestore();
        const adminCollection = collection(db, 'admin');
        const adminQuery = query(adminCollection, where('uid', '==', this.user.uid));
        const adminSnapshot = await getDocs(adminQuery);
        
        this.isSuperAdmin = !adminSnapshot.empty;
        
        if (this.isSuperAdmin) {
          console.log('Usuario confirmado como SuperAdmin');
        } else {
          console.log('Usuario NO es SuperAdmin');
        }
        
      } catch (error) {
        console.error('Error al verificar estado de SuperAdmin:', error);
        this.isSuperAdmin = false;
      }
    },
    toggleSuperAdminMenu(event) {
      event.stopPropagation();
      this.showSuperAdminMenu = !this.showSuperAdminMenu;
      
      // Cerrar otros menús si están abiertos
      if (this.showSuperAdminMenu) {
        this.showLanguageDropdown = false;
        this.showUserMenu = false;
        this.showUserMenuTest = false;
      }
    },
    async checkAdminStatus() {
      if (!this.user?.uid) return;
      try {
        const institution = await educationalInstitutionsData.getInstitutionByAdminUid(this.user.uid);
        this.isEducationalInstitutions = !!institution;
        this.institutionData = institution;
      } catch (error) {
        this.isEducationalInstitutions = false;
        this.institutionData = null;
      }
    },
    // Verifica si estamos en una ruta relacionada con proyectos
    checkProjectsRoute() {
      // Comprobar si la ruta actual está relacionada con proyectos
      this.activateProjects = this.$route.name === 'all-projects' || 
                             this.$route.path.includes('/projects');
    },
    async checkUserRole() {
      const auth = getAuth();
      
      // Esperar a que Firebase Auth inicialice
      if (!auth.currentUser) {
        await new Promise((resolve) => {
          const unsubscribe = auth.onAuthStateChanged((user) => {
            unsubscribe();
            resolve(user);
          });
        });
      }

      const userId = auth.currentUser?.uid;
      if (!userId) return;

      try {
        const tutorGroups = await academyData.getGroupsByTutorId(userId);
        this.isTutor = tutorGroups.length > 0;
      } catch (error) {
        console.error('Error al verificar rol de tutor:', error);
        this.isTutor = false;
      }
    },
    navigateToHome() {
      if (this.$route.path != `/${this.$i18n.locale}/home`) {
        this.$router.push(`/${this.$i18n.locale}/home`);
      }
    },
    navigateToAcademy() {
      if (this.$route.path != `/${this.$i18n.locale}/academy`) {
        this.$router.push(`/${this.$i18n.locale}/academy`);
      }
    },
    navigateToAllProjects() {
      const currentPath = this.$route.path;
      const targetPath = `/${this.$i18n.locale}/projects`;

      if (currentPath !== targetPath) {
        this.$router.push({ name: "all-projects" });
      }
      // this.$router.push({ name: "all-projects" });
    },
    navigateToBackoffice(){
      this.$router.push({ name: "backoffice"})
    },
    navigateToGroups() {
      if (this.$route.name !== 'groups') {
        this.$router.push({ name: 'groups' });
      }
    },
    isActiveRoute(routeName) {
      return this.$route.name === routeName;
    },
    toggleLanguageDropdown(event) {
      // Evitar que el evento se propague
      event.stopPropagation();
      this.showLanguageDropdown = !this.showLanguageDropdown;
      // Cerrar el menú de usuario si está abierto
      if (this.showLanguageDropdown) {
        this.showUserMenu = false;
      }
    },
    setLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        localStorage.setItem('userLocale', locale);
        this.showLanguageDropdown = false;
        
        // Actualizar la URL con el nuevo idioma
        const path = this.$route.path.split('/');
        path[1] = locale;
        this.$router.push(path.join('/'));
      }
    },
    toggleUserMenu(event) {
  event.stopPropagation();
  this.showUserMenu = !this.showUserMenu;
  if (this.showUserMenu) {
    this.showLanguageDropdown = false;
    this.showUserMenuTest = false;
    this.showSuperAdminMenu = false; 
  }
},

    toggleUserMenuTest(e){
      e.stopPropagation();
      this.showUserMenuTest = !this.showUserMenuTest;
      if (this.showUserMenuTest) {
        this.showLanguageDropdown = false;
        this.showUserMenu = false;
        this.showSuperAdminMenu = false; 
      }
    },
    handleClickOutside(event) {
      const userMenu = this.$refs.userMenuWrapper;
      const isClickInUserMenu = userMenu?.contains(event.target);
      const isClickOnMenuButton = event.target.closest('.account-menu-toggle');

      if (this.showUserMenu && !isClickInUserMenu && !isClickOnMenuButton) {
        this.showUserMenu = false;
      }

    if (this.showUserMenuTest && !isClickInUserMenu && !isClickOnMenuButton) {
      this.showUserMenuTest = false;
    }

    if (this.showSuperAdminMenu && !isClickInUserMenu && !isClickOnMenuButton) {
      this.showSuperAdminMenu = false;
    }

    if (
      this.showLanguageDropdown &&
      !this.$el.querySelector('.language-dropdown').contains(event.target) &&
      !event.target.closest('.language-selector')
    ) {
      this.showLanguageDropdown = false;
    }
  },
  }
}

</script>

<style scoped>
.user-menu-wrapper {
  position: absolute;
  left: 0px;
  top: calc(100% + 5px);
  z-index: 1000;
}

/* ✅ NUEVO: POSICIONAMIENTO ESPECÍFICO PARA SUPERADMIN */
li:has(.super-admin-dropdown-menu) .user-menu-wrapper,
li:last-child .user-menu-wrapper {
  left: 220px; /* Más a la derecha del sidebar */
  top: -50px; /* Más arriba */
  transform: translateY(-20px); /* Ajuste fino vertical */
}

/* ✅ ALTERNATIVA: Si :has() no funciona, usar clase específica */
.super-admin-menu-wrapper {
  position: absolute;
  left: 220px !important; /* A la derecha del sidebar */
  top: -50px !important; /* Más arriba */
  z-index: 1000;
  transform: translateY(-20px); /* Ajuste fino */
}

/* ✅ NUEVO: Estilos para el separador de admin */
.admin-separator {
  margin: 15px 0;
  padding: 0 10px;
  cursor: default !important;
}

.admin-separator:hover {
  background-color: transparent !important;
}

.separator-line {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  width: 100%;
  border-radius: 1px;
}

* {
  margin: 0;
  padding: 0;
}

.d-flex {
  min-height: 100vh; /* Asegura que el contenedor flex tenga al menos la altura de la ventana */
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100%;
  min-height: 100vh; /* Altura mínima igual a la ventana */
}

/* En NavBarAcademy.vue */
#sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%; /* Ocupa todo el espacio disponible */
  min-height: 100vh; /* Nunca menos que la altura de la ventana */
  width: 212px;
  padding: 5px 0 1rem 1rem;
  background-color: #0B1427;
  border-radius: 0 20px 20px 0;
  box-sizing: border-box;
}

#sidebar ul {
  list-style: none;
  padding: 0;
}

#sidebar > ul > li {
  cursor: pointer;
  position: relative;
}

#sidebar > ul > li:first-child {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 80px 0;
}

#sidebar .logo {
  font-weight: 600;
  font-size: 26px;
  color: white;
}

#sidebar a {
  padding: 12px 10px;
  text-decoration: none;
  color: white;
  display: flex;
  align-items: center;
  gap: 1em;
}

#sidebar a:hover {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px 0 0 10px;
}

.language-selector {
  margin-left: 3px;
}

#sidebar ul li.active a {
  color: #000;
  background-color: #fff;
  border-radius: 10px 0 0 10px;
}

/* Menú de usuario */
.user-menu-wrapper {
  position: absolute;
  left:0px;
top: calc(100% + 5px)  ;  /* Posiciona el menú más a la derecha del sidebar */
  z-index: 1000;
}

.language-dropdown {
  position: absolute;
  background-color: #1a2942;
  width: 80%;
  border-radius: 5px;
  left: 10px;
  z-index: 100;
}

.language-dropdown a {
  display: block;
  text-align: center;
  padding: 8px !important;
}

.language-dropdown a:hover {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.footer {
  text-align: center;
  color: #fff;
  margin-bottom: 20px;
  font-size: 14px;
}
</style>